var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_8","data-name":"Path 8","d":"M5.212,11.834V7.892H3.988v3.942H.064v1.224H3.988V17H5.212V13.058H9.136V11.834Z","transform":"translate(-0.064 -7.892)"}));
}

Plus.defaultProps = {"width":"9.072","height":"9.108","viewBox":"0 0 9.072 9.108"};

module.exports = Plus;

Plus.default = Plus;
